import { Box } from "@mui/material";
import CompanyCircle from "./CompanyCircle";
import Company from "./Company";
import { companiesData } from "../common/Data"; // Assuming you have a data file for timeline items

const Experience = () => {
  return (
    <div>
      <Box
        component="h2"
        sx={{
          textAlign: "center",
          mb: 2,
          fontWeight: 800,
          fontSize: { xs: 24, sm: 32 },
          letterSpacing: 1,
          color: "#000",
          textShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        Experience
      </Box>
      <Box
        sx={{
          p: { xs: 2, sm: 4 },
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            height: "100%",
            width: "4px",
            bgcolor: "#000",
            borderRadius: "2px",
          },
        }}
      >
        {companiesData.map((item, index) => (
          <>
            {item.type === "brand" && (
              <CompanyCircle
                key={`brand-${index}`}
                companyUrl={item.companyUrl}
                name={item.name}
              />
            )}
            {item.year && (
              <Company
                key={`timeline-${index}`}
                item={item}
                isLeft={item.left ?? false}
              />
            )}
          </>
        ))}
      </Box>
    </div>
  );
};

export default Experience;
